var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 512,
    height: 341.337,
    y: 85.331
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 90.579,
    y: 85.331
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#496e2d"
    },
    width: 512,
    height: 90.568,
    y: 336.089
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a2001d"
    },
    width: 512,
    height: 114.799,
    y: 198.606
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f0f0f0"
    },
    points: "323.265 139.803 297.682 127.994 256 222.376 214.318 127.994 188.735 139.803 240.484 255.994 188.735 372.186 214.318 383.994 256 289.613 297.682 383.994 323.265 372.186 271.516 255.994"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0"
    },
    d: "M273.376,150.931C263.472,140.115,256,133.898,256,133.898s-7.472,6.216-17.376,17.032v210.127 C248.528,371.873,256,378.091,256,378.091s7.472-6.216,17.376-17.033V150.931z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2001d"
    },
    d: "M209.04,191.226v129.535c10.465,18.542,23.274,33.742,32.872,43.818V147.408 C232.313,157.484,219.504,172.683,209.04,191.226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2001d"
    },
    d: "M302.96,191.226c-10.465-18.543-23.274-33.742-32.872-43.818V364.58 c9.599-10.077,22.407-25.276,32.872-43.818V191.226z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.96,191.226v129.535c10.594-18.774,18.784-40.973,18.784-64.767S313.554,210.001,302.96,191.226z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.04,191.226v129.535c-10.594-18.774-18.784-40.973-18.784-64.767S198.446,210.001,209.04,191.226z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwa);
export default __webpack_public_path__ + "static/media/swa.5f0a50cf9d3c0b0a320cc83dd8ad3925.svg";
export { ForwardRef as ReactComponent };